import { Group } from "common/gql";

export default class GQLUtils
{
	static gqlGroupToGroup(group: Group)
	{
		return {
			uuid: group?.id as string,
			name: group?.name as string
		};
	}
}